import { withInstall } from '@zoryn/utils'
import Segmented from './src/segmented.vue'

export const ZSegmented = withInstall(Segmented)
export default ZSegmented

export * from './src/segmented'
